export const SubscriptionTableHead = [
  "Name",
  "Amount",
  "Email",
  "Phone Number",
  "Last Payment",
  "Next Payment",
];
